//
//	Handle rendering of header, basicly for switches between mobile and desktop
//
import React from 'react';
import logo from 'public/media/images/logo.png';
import Search from 'src/components/parts/SearchBox';
import MobileMenu from 'src/components/parts/MobileMenu';
import { NavLink } from 'react-router-dom';
import { connect } from "react-redux";
import Img from 'react-image';

//	This maps the data store to local variables.
const mapStateToProps = state  => {
	return {
		isMobile: state.isMobile
	};
};

class Header extends React.Component {

	constructor(props) {

		super(props);

		//console.log( 'Constructor header is mobile: ' + this.state.isMobile )
		
	}

	/*
	//	On header component mounting will get the actual screen size to correct if we want to display mobile version of site
	componentDidMount() {

		/*
		var width = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth

		if( this.props.isMobile === true && width > 1000 ) {

			this.props.dispatch({type: 'MOBILE_VERSION', value:true});

		} else if( this.props.isMobile === false && width < 1000 ) {

			this.props.dispatch({type: 'MOBILE_VERSION', value:true});

		}

	}
	*/

	renderMobileHeader = () => {
		return(
		  <div className="App-header">
			<a href="/">
				<Img src={logo} className="App-logo" alt="Wish Cams" />
			</a>
			<Search />
			<MobileMenu />
		  </div>
		)
	}

	renderDesktopHeader = () => {
		return(
		  <div className="App-header-desktop">
			<div className="header-left">
				<div className="header-navbar">
					<div className="header-logo">
						<a href="/">
							<Img src={logo} className="App-logo" alt="Wish Cams" /></a>
						<a href="/" title="WishCams Home Page"><h1>WISHCAMS</h1></a>
					</div>
					<ul>
						<li><NavLink to="/" activeClassName="navlink-active" exact>HOME</NavLink></li>
						<li><NavLink to="/tag/asian/" activeClassName="navlink-active">ASIAN</NavLink></li>
						<li><NavLink to="/tag/ebony/" activeClassName="navlink-active">EBONY</NavLink></li>
						<li><NavLink to="/tag/latina/" activeClassName="navlink-active">LATINA</NavLink></li>
						<li><NavLink to="/tag/white/" activeClassName="navlink-active">WHITE</NavLink></li>
						<li><NavLink to="/tag/teen/" activeClassName="navlink-active">TEEN</NavLink></li>
						<li><NavLink to="/tag/milf/" activeClassName="navlink-active">MILF</NavLink></li>
						<li><NavLink to="/tag/mature/" activeClassName="navlink-active">MATURE</NavLink></li>
						<li><NavLink to="/tag/fetish/" activeClassName="navlink-active">FETISH</NavLink></li>
					</ul>
				</div>
			</div>
			<div className="header-right">
				<Search />
			</div>
		  </div>
		)
	}

	
	render() {

		// determin if we should render mobile or desktop version
		if(this.props.isMobile) {

			return(
				this.renderMobileHeader()
			);

		} else {

			return (
				this.renderDesktopHeader()
			);

		}
		
	}
}

export default connect(mapStateToProps)(Header);


// WEBPACK FOOTER //
// ./src/components/parts/Header.js